import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: Routing configuration item
 *
 * hidden: true                   // When true is set, the route will not appear in the sidebar, such as 401, login and other pages, or some editing pages / edit / 1
 * alwaysShow: true               // When you have more than one route declared by children under a route, it will automatically become a nested mode -- such as component page
 *                                // When there is one, the sub route will be displayed in the sidebar as the root route, such as the guidance page
 *                                // If you want to display your root route regardless of the number of children declarations below
 *                                // You can set alwaysshow: true so that it will ignore the previously defined rules and always display the root route
 * redirect: noRedirect           // When noredirect is set, the route cannot be clicked in the breadcrumb navigation
 * name:'router-name'             // The name of the route must be filled in, otherwise various problems will occur when using < keep alive >
 * meta : {
    roles: ['admin','editor']    // Set the access permission of this route, and support multiple permission superposition
    title: 'title'               // Set the name of the route displayed in the sidebar and breadcrumbs
    icon: 'svg-name'             // Set the icon of the route, corresponding to the path Src / icons / SVG
    breadcrumb: false            // If set to false, it does not appear in breadcrumb breadcrumbs
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect')
      }
    ]
  },
  {
    path: '/sign',
    component: () => import('@/views/sign/index.vue'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  // {
  //   path: '/user',
  //   component: Layout,
  //   hidden: true,
  //   redirect: 'noredirect',
  //   children: [
  //     {
  //       path: 'profile',
  //       component: () => import('@/views/system/user/profile/index'),
  //       name: 'Profile',
  //       meta: { title: 'Personal Center', icon: 'user' }
  //     }
  //   ]
  // }
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
